import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#F39325",
    },
    secondary: {
      main: "#1b374c",
    },
    info: {
      main: "#fff",
    },
  },
  typography: {
    fontFamily: ["Fira Sans", "sans-serif"].join(","),
  },
});
